import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { get } from 'lodash-es';
import { Link } from 'site-modules/shared/components/link/link';

export const EmailFormDisclaimer = ({
  className = '',
  ctaText = 'Send',
  withDisclaimerSymbol = true,
  disclaimerSymbol = '†',
  emailDisclaimerId = '',
}) => {
  const isAppExtensionPage = useSelector(state => get(state, 'pageContext.isAppExtensionPage'));
  const extension = isAppExtensionPage ? 'app' : 'html';

  const visitorAgreementLink = (
    <Link
      to={`/about/visitor-agreement.${extension}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-underline"
    >
      Edmunds Visitor Agreement
    </Link>
  );

  const privacyLink = (
    <Link to={`/about/privacy.${extension}`} target="_blank" rel="noopener noreferrer" className="text-underline">
      Our collection and use of your personal information
    </Link>
  );

  return (
    <p id={emailDisclaimerId} className={className}>
      <span hidden={!withDisclaimerSymbol}>{disclaimerSymbol} </span>
      By clicking {ctaText}, I accept the terms of the {visitorAgreementLink}. {privacyLink}.
    </p>
  );
};

EmailFormDisclaimer.propTypes = {
  className: PropTypes.string,
  ctaText: PropTypes.string,
  withDisclaimerSymbol: PropTypes.bool,
  disclaimerSymbol: PropTypes.string,
  emailDisclaimerId: PropTypes.string,
};
